import { observer } from "mobx-react";
import { CloseSquare, Copy } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Button, Typography, Stack } from "@mui/material";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon
} from "react-share";
import styles from './shared.module.scss';
import { useEffect, useState } from "react";

const ReferralModal = observer(({ code, show, setShow }) => {

    const [url, setUrl] = useState(code);
    

    useEffect(() => {
        setUrl(code);
        
    }, [code])

    return (
        <Dialog open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                Refer a friend
                <Typography color='#888' fontSize={14}>Share with your friends and get cash in your wallet</Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                <Box sx={{ textAlign: 'right', mb: 3 }}>
                    <Box className={styles.urlBox}>
                        {url}
                    </Box>
                    <Button
                        variant="contained"
                        endIcon={<Copy
                            size="24"
                            variant="Bulk"
                        />} color="primary"
                        onClick={() => navigator.clipboard.writeText(url)}
                    >
                        Copy Link
                    </Button>
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <Typography fontSize={14} sx={{ mr: 2 }}>Share on Social</Typography>
                    <Stack direction="row" spacing={2}>
                        <FacebookShareButton url={url}>
                            <FacebookIcon size={24} round />
                        </FacebookShareButton>
                        <TwitterShareButton url={url}>
                            <TwitterIcon size={24} round />
                        </TwitterShareButton>
                        <LinkedinShareButton url={url}>
                            <LinkedinIcon size={24} round />
                        </LinkedinShareButton>
                    </Stack>
                </Box>
            </DialogContent>
        </Dialog>
    );
});

export default ReferralModal;
